const options = {
  rootMargin: '-5%',
}

const callback = (entries) => {
  for (const entry of entries) {
    if (entry.isIntersecting) {
      entry.target.dataset.reveal = true
    }
  }
}

const observer = new IntersectionObserver(callback, options)
const medias = document.querySelectorAll('.vp-main > *:not(.no-reveal)')

for (const media of medias) {
  observer.observe(media)
}
